export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SAVE_CUSTOMER = 'SAVE_CUSTOMER';
export const GET_CUSTOMER = 'GET_CUSTOMER';
export const SELECTED_CARD = 'SELECTED_CARD';
export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';

export interface CustomerData {
  cid: string;
  email: string;
  source: string;
}

export interface CustomerCard {
  card: string;
  expMonth: string;
  expYear: string;
  cvc: string;
  email: string;
}

export interface CustomerState {
  customers: any;
  id: string;
  cid: string;
  email: string;
  source: string;
  user: string;
  usetype: string;
  cusToken: string;
}

export interface Customers {
  customers: CustomerState[];
  selected: string;
}

export interface SetCustomerDataAction extends Customers {
  type: typeof SET_CUSTOMER;
  customers: CustomerState[];
}

export interface SaveCustomerAction extends Customers {
  type: typeof SAVE_CUSTOMER;
  customers: CustomerState[];
}

export interface GetCustomerAction extends Customers {
  type: typeof GET_CUSTOMER;
}

export interface SelectCardAction extends Customers {
  type: typeof SELECTED_CARD;
  selected: string;
}

export interface CreateStipeCustomer extends Customers {
  type: typeof CREATE_CUSTOMER;
  customerCard: CustomerCard;
}

export type CustomerDataActionTypes =
  | SetCustomerDataAction
  | GetCustomerAction
  | SelectCardAction;
